import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PhoneIcon } from "../../../images/learnersimage/phoneicon.svg";
import { ReactComponent as NameIcon } from "../../../images/learnersimage/nameicon.svg";
import { ReactComponent as EmailIcon } from "../../../images/learnersimage/emailicon.svg";
import { Autocomplete } from "@material-ui/lab";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import DeleteIcon from "@material-ui/icons/Delete";
import { sanitizeInput } from "../../../../Utils/validationUtils";

function AddCenterForm() {
  const classes = useStyles();

  const initialData = {
    center_name: "",
    center_code: "",
    phone: "",
    email: "",
    contact_person_name: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    password: "",
    course_id: "",
    batch_id: "",
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [pincodeError, setPincodeError] = useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");

  const [formDetails, setFormDetails] = useState(initialData);
  const [centerName, setCenterName] = useState("");

  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [states, setStates] = useState([]);

  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictId, setSelectedDistrictId] = useState("");

  // State for student email error
  const [emailError, setEmailError] = useState(false);

  // New state_id for phone number error message
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");
  // New state_id for phone number error
  const [phoneError, setPhoneError] = useState(false);

  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [courseBatchesMap, setCourseBatchesMap] = useState({});

  const fetchCources = async () => {
    try {
      const token = decryptData(sessionStorage.getItem("token"));

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCources(response.data.courses);

    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  useEffect(() => {
    fetchCources();
  }, []);

  const handleCourceChange = (event, newValue) => {
    setSelectedCourse(newValue.map((cource) => cource.id));
  };

  const fetchBatches = async () => {
    try {
      const token = decryptData(sessionStorage.getItem("token"));

      if (selectedCourse && selectedCourse.length > 0) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
          {
            batch: {
              course_ids: selectedCourse,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const newBatches = response.data.batches || [];
        setBatches(newBatches);

        const map = {};
        newBatches.forEach((b) => {
          const cId = b.course_id || b.courseId;
          if (cId) {
            if (!map[cId]) map[cId] = [];
            map[cId].push(b);
          }
        });

        const missingCourseIds = selectedCourse.filter(
          (id) => !map[id] || map[id].length === 0
        );
        if (missingCourseIds.length > 0) {
          if (selectedCourse.length === 1) {
            map[selectedCourse[0]] = newBatches;
          } else {
            await Promise.all(
              missingCourseIds.map(async (cId) => {
                try {
                  const res = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
                    { batch: { course_ids: [cId] } },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  map[cId] = res.data.batches || [];
                } catch (e) {
                  map[cId] = [];
                }
              })
            );
          }
        }

        setCourseBatchesMap(map);

        setSelectedBatch((prev) => {
          if (!Array.isArray(prev)) return [];
          const validIds = new Set(newBatches.map((b) => b.id));
          return prev.filter((id) => validIds.has(id));
        });
      } else {
        setBatches([]);
        setSelectedBatch([]);
        setCourseBatchesMap({});
      }

    } catch (error) {
      console.error("Error fetching batches data:", error);
      setBatches([]);
      setSelectedBatch([]);
      setCourseBatchesMap({});
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [selectedCourse]);

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue.map((batch) => batch.id));
  };

  const getBatchesForCourse = (courseId) => {
    if (Array.isArray(selectedCourse) && selectedCourse.length === 1) {
      return batches;
    }
    if (courseBatchesMap[courseId] && courseBatchesMap[courseId].length > 0) {
      return courseBatchesMap[courseId];
    }
    return batches.filter(
      (b) => String(b.course_id || b.courseId) === String(courseId)
    );
  };

  const handleDeleteCourse = (courseId) => {
    setSelectedCourse((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return arr.filter((id) => id !== courseId);
    });

    const thisCourseBatches = getBatchesForCourse(courseId);
    const thisCourseBatchIds = new Set(thisCourseBatches.map((b) => b.id));
    setSelectedBatch((prev) => {
      if (!Array.isArray(prev)) return [];
      return prev.filter((id) => !thisCourseBatchIds.has(id));
    });
  };

  const handleRemoveSingleBatch = (batchId) => {
    setSelectedBatch((prev) => {
      if (!Array.isArray(prev)) return [];
      return prev.filter((id) => id !== batchId);
    });
  };

  const handleToggleCourseBatches = (courseId) => {
    const thisCourseBatches = getBatchesForCourse(courseId);
    const thisCourseBatchIds = thisCourseBatches.map((b) => b.id);
    const currentSelected = Array.isArray(selectedBatch) ? selectedBatch : [];
    const allSelectedForCourse =
      thisCourseBatchIds.length > 0 &&
      thisCourseBatchIds.every((id) => currentSelected.includes(id));

    if (allSelectedForCourse) {
      const toRemove = new Set(thisCourseBatchIds);
      setSelectedBatch((prev) =>
        Array.isArray(prev) ? prev.filter((id) => !toRemove.has(id)) : []
      );
    } else {
      const newSet = new Set([...currentSelected, ...thisCourseBatchIds]);
      setSelectedBatch(Array.from(newSet));
    }
  };

  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
    console.log("Password visibility toggled:", !showPassword); // Debugging
  };

  const handleClose = () => {
    navigate("/admin/center");
  };

  const fetchStates = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state`
      );

      setStates(response.data.states);

    } catch (error) {
      console.error("Error fetching states data:", error);
    }
  };
  useEffect(() => {
    fetchStates();
  }, []);

  const fetchDistricts = async (selectedStateId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/state/${selectedStateId}`
      );

      setDistricts(response.data.cities);

    } catch (error) {
      console.error("Error fetching districts data:", error);
    }
  };
  useEffect(() => {
    if (selectedStateId) {
      fetchDistricts(selectedStateId);
    }
  }, [selectedStateId]);

  // Function to validate email
  const validateEmail = (email) => {
    // Standard email regex pattern
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (email) => {
    if (!validateEmail(email)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    handleFormChange("email", email); // Assuming your state_id field is named 'studentEmail'
  };

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setSelectedStateId(value.id);
  };
  const handleDistrictChange = (event, value) => {
    setSelectedDistrict(value);
    setSelectedDistrictId(value.id);
  };

  // Updated phone field handler
  const handlePhoneChange = (value) => {
    const phoneRegex = /^[6789]\d{0,9}$/; // Updated regex to allow only 10 digits

    // Check if the input starts with 6, 7, 8, or 9 and is up to 10 digits long
    if (phoneRegex.test(value) || value === "") {
      setPhoneErrorMessage("");
      setPhoneError(false);
      handleFormChange("phone", value);
    } else {
      if (value.length <= 10) {
        setPhoneErrorMessage("Phone number should start with 6, 7, 8, or 9.");
        setPhoneError(true);
      }
    }
  };
  const handlePincodeChange = (value) => {
    if (/[^0-9]/.test(value)) {
      setPincodeError(true);
      setPincodeErrorMessage("Pincode should be number");
      return;
    }

    if (value.length <= 6) {
      if (value.length === 6 || value === "") {
        setPincodeError(false);
        setPincodeErrorMessage("");
      } else {
        setPincodeError(true);
        setPincodeErrorMessage("Pincode must be exactly 6 digits");
      }
      setFormDetails((prevFormDetails) => ({
        ...prevFormDetails,
        pincode: value,
      }));
    }
  };

  const handleFormChange = (fieldName, value) => {
    setFormDetails((prevFormDetails) => ({
      ...prevFormDetails,
      [fieldName]: value,
    }));
  };

  const handleFormSubmit = async () => {
    // Reset password error state before validation
    setPasswordError(false);
    setPasswordErrorMessage("");
    console.log("emailErroradd", emailError);
    // Other validations as before..
    if (
      !centerName.trim() ||
      !formDetails?.center_code?.trim() ||
      !formDetails?.contact_person_name?.trim() ||
      !formDetails?.phone?.trim() ||
      emailError ||
      (!selectedCourse || (Array.isArray(selectedCourse) && selectedCourse.length === 0) || (typeof selectedCourse === "string" && !selectedCourse.trim())) ||
      (!selectedBatch || (Array.isArray(selectedBatch) && selectedBatch.length === 0) || (typeof selectedBatch === "string" && !selectedBatch.trim())) ||
      (typeof selectedStateId === "string" && !selectedStateId.trim()) ||
      (typeof selectedDistrictId === "string" && !selectedDistrictId.trim())
    ) {
      if (!centerName.trim()) {
        toast.warn("Please enter a Branch name.");
      } else if (!formDetails?.center_code?.trim()) {
        toast.warn("Please enter center code.");
      } else if (!formDetails?.contact_person_name?.trim()) {
        toast.warn("Please enter contact person name.");
      } else if (!formDetails?.phone?.trim()) {
        toast.warn("Please enter a phone number.");
      } else if (emailError) {
        toast.warn("Please enter a valid email address");
      } else if (!formDetails?.email?.trim()) {
        toast.warn("Please enter an email.");
      } else if (!formDetails?.password?.trim()) {
        toast.warn("Please enter a password.");
      } else if (!selectedCourse || (Array.isArray(selectedCourse) && selectedCourse.length === 0) || (typeof selectedCourse === "string" && !selectedCourse.trim())) {
        toast.warn("Please select a course.");
      } else if (!selectedBatch || (Array.isArray(selectedBatch) && selectedBatch.length === 0) || (typeof selectedBatch === "string" && !selectedBatch.trim())) {
        toast.warn("Please select a batch.");
      } else if (
        typeof selectedStateId === "string" &&
        !selectedStateId.trim()
      ) {
        toast.warn("Please select a state.");
      } else if (
        typeof selectedDistrictId === "string" &&
        !selectedDistrictId.trim()
      ) {
        toast.warn("Please select a city.");
      }

      return;
    }

    // Validate password length
    if (formDetails.password.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long");
      toast.warn("Password must be at least 6 characters long");
      return; // Prevent form submission
    }

    if (formDetails.pincode && formDetails.pincode.length !== 6) {
      setPincodeError(true);
      setPincodeErrorMessage("Pincode must be exactly 6 digits");
      toast.warn("Pincode must be exactly 6 digits");
      return;
    }

    const data = {
      center: {
        center_name: centerName,
        center_code: formDetails.center_code,
        phone: formDetails.phone,
        email: formDetails.email,
        contact_person_name: formDetails.contact_person_name,
        address: formDetails.address ? formDetails.address : null,
        state: selectedStateId ? selectedStateId : null,
        city: selectedDistrictId ? selectedDistrictId : null,
        pincode: formDetails.pincode ? formDetails.pincode : null,
        password: formDetails.password,
        course_id: selectedCourse,
        batch_id: selectedBatch,
      },
    };

    axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        toast.success("Branch created successfully");
        setTimeout(() => {
          navigate("/admin/center");
        }, 2000);
      })
      .catch((error) => {
        console.log("objecterror", error.response);
        toast.error(error.response.data.error);
      });
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Branch Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => setCenterName(sanitizeInput(e.target.value, "textInput"))}
                  value={centerName}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Branch Name"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.center_code}
                  onChange={(e) =>
                    handleFormChange("center_code", sanitizeInput(e.target.value, "textInput"))
                  }
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Branch Code"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Contact Person Name{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.contact_person_name}
                  onChange={(e) =>
                    handleFormChange("contact_person_name", sanitizeInput(e.target.value, "textInput"))
                  }
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Contact Person Name"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <NameIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Mobile No. <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  value={formDetails.phone}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="91XXXXXXXX"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for phone */}
                {phoneError && (
                  <Typography color="error" className={classes.errorMessage}>
                    {phoneErrorMessage}
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Email Address <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  onChange={(e) => handleEmailChange(e.target.value)}
                  value={formDetails.email}
                  type="email"
                  variant="outlined"
                  required
                  placeholder="Enter Email Address"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Display error message for student email */}
                {emailError && (
                  <Typography color="error" className={classes.errorMessage}>
                    Please enter a valid email address
                  </Typography>
                )}
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Create Password{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  placeholder="********"
                  value={formDetails.password}
                  onChange={(e) => handleFormChange("password", e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleToggleShowPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={cources}
                  getOptionLabel={(option) => option.course_name}
                  value={cources.filter((cou) =>
                    selectedCourse.includes(cou.id)
                  )}
                  onChange={handleCourceChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderTags={() => null}
                  renderOption={(option, { selected }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        size="small"
                        color="primary"
                        style={{ marginRight: 8, padding: 0 }}
                        checked={selected}
                      />
                      <span>{option.course_name}</span>
                    </div>
                  )}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder={
                        Array.isArray(selectedCourse) && selectedCourse.length > 0
                          ? `${selectedCourse.length} Course${selectedCourse.length > 1 ? "s" : ""} Selected`
                          : "Type to pick Course..."
                      }
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Batch <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  {selectedCourse?.length > 0 && batches?.length > 0 && (
                    <Button
                      size="small"
                      color="primary"
                      style={{ textTransform: "none", fontSize: "12px", padding: "0 4px", minWidth: "auto" }}
                      onClick={() => {
                        if (Array.isArray(selectedBatch) && selectedBatch.length === batches.length) {
                          setSelectedBatch([]);
                        } else {
                          setSelectedBatch(batches.map((bat) => bat.id));
                        }
                      }}
                    >
                      {Array.isArray(selectedBatch) && selectedBatch.length === batches.length
                        ? "Deselect All"
                        : "Select All"}
                    </Button>
                  )}
                </div>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((bat) =>
                    selectedBatch.includes(bat.id)
                  )}
                  onChange={handleBatchChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderTags={() => null}
                  renderOption={(option, { selected }) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        size="small"
                        color="primary"
                        style={{ marginRight: 8, padding: 0 }}
                        checked={selected}
                      />
                      <span>{option.batch_name}</span>
                    </div>
                  )}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder={
                        Array.isArray(selectedBatch) && selectedBatch.length > 0
                          ? `${selectedBatch.length} Batch${selectedBatch.length > 1 ? "es" : ""} Selected`
                          : "Type to pick Batch..."
                      }
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
            </div>
            {Array.isArray(selectedCourse) && selectedCourse.length > 0 && (
              <div
                className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1_5}`}
              >
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div className={`${classes.w74}`}>
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      overflow: "hidden",
                    }}
                  >
                    <Table size="small">
                      <TableHead style={{ backgroundColor: "#f8fafc" }}>
                        <TableRow>
                          <TableCell
                            style={{
                              fontWeight: 600,
                              width: "50px",
                              fontFamily: "Outfit, sans-serif",
                              color: "#374151",
                              borderBottom: "2px solid #e2e8f0",
                            }}
                          >
                            #
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: 600,
                              width: "220px",
                              fontFamily: "Outfit, sans-serif",
                              color: "#374151",
                              borderBottom: "2px solid #e2e8f0",
                            }}
                          >
                            Course Name
                          </TableCell>
                          <TableCell
                            style={{
                              fontWeight: 600,
                              fontFamily: "Outfit, sans-serif",
                              color: "#374151",
                              borderBottom: "2px solid #e2e8f0",
                            }}
                          >
                            Batch
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              fontWeight: 600,
                              width: "90px",
                              fontFamily: "Outfit, sans-serif",
                              color: "#374151",
                              borderBottom: "2px solid #e2e8f0",
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedCourse.map((cId, index) => {
                          const courseObj = cources.find((c) => c.id === cId);
                          const courseName = courseObj
                            ? courseObj.course_name
                            : `Course ${cId}`;
                          const thisCourseBatches = getBatchesForCourse(cId);
                          const selectedInThisCourse = (
                            Array.isArray(selectedBatch) ? selectedBatch : []
                          )
                            .map((bId) =>
                              thisCourseBatches.find((b) => b.id === bId)
                            )
                            .filter(Boolean);

                          return (
                            <TableRow key={cId} hover>
                              <TableCell
                                style={{
                                  fontFamily: "Outfit, sans-serif",
                                  color: "#6b7280",
                                  verticalAlign: "middle",
                                }}
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell
                                style={{
                                  fontFamily: "Outfit, sans-serif",
                                  fontWeight: 600,
                                  color: "#1e293b",
                                  verticalAlign: "middle",
                                }}
                              >
                                {courseName}
                              </TableCell>
                              <TableCell
                                style={{
                                  verticalAlign: "middle",
                                  padding: "8px 16px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      flex: 1,
                                    }}
                                  >
                                    {selectedInThisCourse.length > 0 ? (
                                      selectedInThisCourse.map((b) => (
                                        <Chip
                                          key={b.id}
                                          size="small"
                                          label={b.batch_name}
                                          onDelete={() =>
                                            handleRemoveSingleBatch(b.id)
                                          }
                                          style={{
                                            backgroundColor: "#e0f2fe",
                                            color: "#0369a1",
                                            fontWeight: 500,
                                            fontFamily: "Outfit, sans-serif",
                                            fontSize: "12px",
                                          }}
                                        />
                                      ))
                                    ) : (
                                      <Typography
                                        variant="caption"
                                        style={{
                                          fontFamily: "Outfit, sans-serif",
                                          color: "#9ca3af",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        No batches selected (pick from Batch field above)
                                      </Typography>
                                    )}
                                  </div>
                                  {thisCourseBatches.length > 0 && (
                                    <Button
                                      size="small"
                                      color="primary"
                                      style={{
                                        textTransform: "none",
                                        fontSize: "11px",
                                        padding: "0 6px",
                                        minWidth: "auto",
                                        fontFamily: "Outfit, sans-serif",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() =>
                                        handleToggleCourseBatches(cId)
                                      }
                                    >
                                      {selectedInThisCourse.length ===
                                      thisCourseBatches.length
                                        ? "Deselect All"
                                        : "Select All"}
                                    </Button>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ verticalAlign: "middle" }}
                              >
                                <Tooltip title="Delete Course">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteCourse(cId)}
                                    style={{
                                      color: "#ef4444",
                                      backgroundColor:
                                        "rgba(239, 68, 68, 0.08)",
                                      padding: "6px",
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Address
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w74} `}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1}
                 ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Address
                </FormLabel>
                <TextField
                  value={formDetails.address}
                  onChange={(e) => handleFormChange("address", e.target.value)}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Type Here"
                  multiline
                  rows={6}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  State <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="state-autocomplete"
                  options={states || []}
                  value={selectedState}
                  onChange={handleStateChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select State"
                      variant="outlined"
                      {...params}
                    />
                  )}
                  selectOnFocus
                  openOnFocus
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  City <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="district_id"
                  options={districts || []}
                  value={selectedDistrict}
                  onChange={handleDistrictChange}
                  disableClearable
                  getOptionLabel={(option) => option.name}
                  autoHighlight
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select City"
                      variant="outlined"
                      {...params}
                    />
                  )}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} 
              ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Pincode
                </FormLabel>
                <TextField
                  name="pincode"
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Pincode"
                  value={formDetails.pincode}
                  onChange={(e) => handlePincodeChange(e.target.value)}
                  error={pincodeError}
                  helperText={pincodeError ? pincodeErrorMessage : ""}
                  inputProps={{ maxLength: 6 }}
                />
              </div>
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddCenterForm;
